import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives/directives.module';
import { SidebarSubmenuDirective } from './sidebar-submenu.directive';
import { SidebarComponent } from './sidebar.component';
import { TcwSidebarStylesDirective } from './twc-sidebar-styles.directive';

@NgModule({
    declarations: [SidebarComponent, TcwSidebarStylesDirective, SidebarSubmenuDirective],
    imports: [
        CommonModule,
        RouterModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
        DirectivesModule,
    ],
    exports: [SidebarComponent],
})
export class SidebarModule {}
